import escape from './escape';

/**
 * A template tag function that contructs URLs by escaping all interpolations
 * using `encodeURIComponent`. Example usage:
 *
 *     encodeUrl`/users/${user}`
 */
const encodeUrl = escape(encodeURIComponent);

export default encodeUrl;
